import VModalModule from '@febe95/vue-js-modal'
import { cjsDefault } from '~/lib/cjsDefault'

const VModal = cjsDefault(VModalModule)

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VModal, { dynamicDefaults: { shiftY: 0, styles: { marginTop: '10px' }, dynamic: true, injectModalsContainer: true }})
  return {}
})